module.exports = __webpack_public_path__ + "img/coronamajesty_053022KV.53609204.jpg";